import { createFileRoute } from '@tanstack/react-router';
import { InscriptionDetail } from '@/features/inscriptions';

function InscriptionDetailPage() {
  const { id, subscriptionId } = Route.useParams();
  return <InscriptionDetail userId={id} subscriptionId={subscriptionId} />;
}

export const Route = createFileRoute('/_auth/_shell/usuarios/$id_/inscricoes/$subscriptionId')({
  component: InscriptionDetailPage,
});
